/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react'
import { useHistory } from 'react-router'

export default function BackButton() {
  const history = useHistory()
  return (
    <div className="flex">
      <div onClick={() => history.goBack()} className="font-bold text-gray-600">
        <i className="fas fa-angle-double-left"></i> กลับ
      </div>
    </div>
  )
}
